<template>
  <div class="ugo-form-field">
  <FormViewItem v-if="as_view" :label="label || ''">
    <span v-if="!viewUsers.length" class="ugo-form-view-empty">—</span>
    <div v-else class="ugo-form-view-users flex-wrap">
      <div v-for="user in viewUsers" :key="user.id" class="flex-wrap ugo-form-view-user">
        <BaseAvatar size="20" :src="user.avatar">{{ user.name ? user.name[0] : '-' }}</BaseAvatar>
        <span class="ugo-form-view-user-name">{{ user.name }}</span>
      </div>
    </div>
  </FormViewItem>
  <FormItem v-else :label="label || ''" :prop="fkey">
    <BaseUserSelectGrouped
      :value="value"
      @input="handleInput"
      v-bind="lConfig"
      :editable="editable"
      :option="{
        multiple:lConfig.multiple
      }"
    />
  </FormItem>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
import asViewMixin from '../mixins/as-view';
export default {
  mixins: [defaultValueMixin, valueDefMixin, asViewMixin],
  valueDefControl: 'UgoUserSelect',
  cname: '用户选择',
  icon: 'xialaliebiao',
  corder: 32,
  props: ['fkey', 'label', 'config', 'value', 'editable'],
  properties: [{
    label: '多选',
    key: 'multiple',
    control: 'Check',
  }],
  computed: {
    ...mapGetters('session', ['users']),
    lConfig() {
      return this.config || {};
    },
    viewUserIds() {
      if (Array.isArray(this.value)) {
        return this.value;
      }
      if (this.value) {
        return [this.value];
      }
      return [];
    },
    viewUsers() {
      return this.viewUserIds
        .map((id) => this.users.find((u) => u.id == id))
        .filter(Boolean);
    },
  },
  methods: {
    getValueDef() {
      return this.valueDefUserSelect();
    },
    handleInput(e) {
      this.$emit('input', e);
    },
  },
};
</script>

<style lang="less" scoped>
.ugo-form-view-users {
  flex-wrap: wrap;
  gap: 8px 16px;
}

.ugo-form-view-user {
  align-items: center;
  gap: 6px;
}

.ugo-form-view-user-name {
  color: var(--text3);
  font-size: 14px;
}
</style>
